// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type NotePencilFillSvgrepoComsvgIconProps =
  React.ComponentProps<"svg"> & {
    title?: string;
  };

export function NotePencilFillSvgrepoComsvgIcon(
  props: NotePencilFillSvgrepoComsvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      viewBox={"0 0 256 256"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M229.651 58.343l-32-32a8 8 0 00-11.314 0l-96 96A8 8 0 0087.994 128v32a8 8 0 008 8h32a8 8 0 005.657-2.343l96-96a8 8 0 000-11.314zm-29.657 18.344L179.308 56l12.686-12.687L212.681 64zm24 43.313v88a16.018 16.018 0 01-16 16h-160a16.018 16.018 0 01-16-16V48a16.018 16.018 0 0116-16h88a8 8 0 010 16h-88v160h160v-88a8 8 0 0116 0z"
        }
      ></path>
    </svg>
  );
}

export default NotePencilFillSvgrepoComsvgIcon;
/* prettier-ignore-end */
